import React, {useState, useEffect} from 'react';
import ListItem from './ListItem';
import axios from 'axios';

var i = window.location.search.match(/^\?(qr)=(.*?)([&]{1}|$)/);
global.qr = i !== null && typeof (i[1]) !== undefined && typeof (i[2]) !== undefined && i[1] === 'qr' ? i[2] : false;

function Main() {
    const [listCoffee, setListCoffee] = useState([]);
    useEffect(() => {
        fetch('https://monitor.rusholts.ru/rhcoffee/getToken.php').then((function (e) {
            return e.text();
        })).then((function (e) {
            global.config = JSON.parse(e);
            const fetchData = async () => {
                const result = await axios(
                    `https://monitor.rusholts.ru/rhcoffee/?predel=1&token=` + global.config.token,
                );
                setListCoffee(result.data.filter(dat => dat.type.trim() === 'usual'));
            };
            fetchData();
        }));
    }, []);
    return (
        <div className="App container">
            <div className="animated slideInUpTiny animation-duration-3">
                {listCoffee.map((data, index) => (
                    <ListItem key={index} data={data} styleName="card-simple"/>
                ))}
            </div>
        </div>
    );
}

export default Main;
